module.exports = import("https://esm.sh/docx@8.5.0");;